import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class DistributorCountryService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllCountries() {
        return this.baseApiFactory.get<any[]>('/api/DistributorCountries');
    }
}

lazyRegister.service('DistributorCountryService', DistributorCountryService);